/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ds_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it convert bits too?`)
};

const es_ds_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿También convierte bits?`)
};

const de_ds_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnet es auch Bit um?`)
};

const nl_ds_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converteert het ook bits?`)
};

const fr_ds_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertit-il également les bits ?`)
};

const it_ds_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converte anche i bit?`)
};

const pt_br2_ds_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ela também converte bits?`)
};

const pt_ds_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Também converte bits?`)
};

const ja_ds_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビットも変換しますか?`)
};

const zh_ds_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它也能换算比特吗?`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ds_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ds_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ds_faq2_q", locale)
	if (locale === "en") return en_ds_faq2_q(inputs)
	if (locale === "es") return es_ds_faq2_q(inputs)
	if (locale === "de") return de_ds_faq2_q(inputs)
	if (locale === "nl") return nl_ds_faq2_q(inputs)
	if (locale === "fr") return fr_ds_faq2_q(inputs)
	if (locale === "it") return it_ds_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_ds_faq2_q(inputs)
	if (locale === "pt") return pt_ds_faq2_q(inputs)
	if (locale === "ja") return ja_ds_faq2_q(inputs)
	return zh_ds_faq2_q(inputs)
};